// IMPORTANT: Keep in sync with:
// - packages/api/auth0/roles/get-highest-tier-role.js
// - terraform/modules/metarouter/auth0/roles/main.tf (role definitions)
// - terraform/modules/metarouter/auth0/trigger_actions/auth0-add-jwt-claims.js (ROLE_PRIORITY)

export const AUTH0_USER_ROLES = {
  ADMIN: 'Admin',
  METAROUTER_SUPER_ADMIN: 'MetaRouter Super Admin',
  DEPLOYMENT_MANAGER: 'Deployment Manager',
  INTEGRATION_MANAGER: 'Integration Manager',
  READ_ONLY: 'Read-Only',
  CONTROL_ADMIN: 'Control Admin',
  CONTROL_READ_ONLY: 'Control Read Only',
  READ_EVENTS: 'Read Events',
};
